/**
* One Column Form JS
* -----------------------------------------------------------------------------
*
* All the JS for the One Column Form component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'one-column-form',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // saves the current repeater field remove button
      let removeBtn = '';

      $( document ).on( 'click', '.add_repeater_item', function( event ) {
        window.easyToggleState();
        $( '.nested-alert__btn' ).removeClass( 'hidden' );
        $( '.remove_repeater_item' ).attr( 'onclick', 'gformDeleteRepeaterItem(this)' );
      } );

      gform.addFilter( 'gform_repeater_item_pre_add', function( clone, item ) {
        const alert = item.find( '.repeater-alert' );
        setTimeout( () => {
          const nestedFormTitle = item.parents( '.gfield_repeater' ).children( 'legend.gfield_label' ).text();
          alert.text( `new ${nestedFormTitle} fields added` );
        }, 0 );
        return clone;
      } );

      $( document ).on( 'gform_post_render', function( event, formId ) {
        $( '.form-skin' );
        $( '.form-skin' ).find( '.gfield_repeater' ).each( function( index, element ) {
          $( '.remove_repeater_item' ).attr( 'onclick', 'gformDeleteRepeaterItem(this)' );
          if ( $( element ).find( '.gfield_repeater_item' ).length > 1 ) {
            $( '.nested-alert__btn' ).removeClass( 'hidden' );
          }
          window.easyToggleState();
        } );
      } );

      // trigger the alert pop up
      $( document ).on( 'click', '.nested-alert__btn', function( event ) {
        // set the correct focus in the dialog
        setTimeout( () => {
          $( '.nested-alert__cancel-btn' ).trigger( 'focus' );
        }, 10 );
        removeBtn = $( event.target ).parents( '.gfield_repeater_buttons' ).find( '.remove_repeater_item' );
      } );

      // trigger the gravity form remove button
      $( document ).on( 'click', '.nested-alert__delete-btn', function( event ) {
        $( removeBtn ).trigger( 'click' );
        const items = $( event.target ).parents( '.gform_fields' ).find( '.gfield_repeater_item' );
        const input = $( event.target ).parents( '.gform_fields' ).find( '.gfield_repeater_item' ).find( 'input' )[0];
        $( input ).trigger( 'focus' );
        $( '.nested-alert__cancel-btn' ).trigger( 'click' );
        if ( items.length === 1 ) {
          $( items[0] ).find( '.nested-alert__btn' ).addClass( 'hidden' );
        }
      } );
    },
    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'one-column-form', COMPONENT );
} )( app );
